import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useAcceptRequestMutation, useDeclineRequestMutation, useDeleteRequestMutation, useGetEmployeeRequestsPaginatedQuery } from "../api/absenceReportApiSlice"
import AbsenceRequestsTable, { KEY_ABSENCEREQUEST_ACTION_ACCEPT, KEY_ABSENCEREQUEST_ACTION_CANCEL_MY, KEY_ABSENCEREQUEST_ACTION_DELETE, KEY_ABSENCEREQUEST_ACTION_DENY } from "./AbsenceRequestsTable"
import Loading from "components/commons/Loading"


const EmployeeAbsences = ({ userGUID }) => {

    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const [requestPage, setRequestPage] = useState(0)


    console.log("userGUID: " + userGUID)

    const {
        data: response,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetEmployeeRequestsPaginatedQuery({
        userGUID: userGUID,
        pageNumber: requestPage
    })

    const [acceptRequest, accepetingResult] = useAcceptRequestMutation()
    const [declineRequest, decliningResult] = useDeclineRequestMutation()
    const [deleteRequest, deletingResult] = useDeleteRequestMutation()

    return <>

        {
            isSuccess ?
            <AbsenceRequestsTable
                items={response.content}
                isLoadingContent={isFetching}
                onRequestAccepted={(guid)=>acceptRequest(guid)}
                onRequestDenied={(guid)=>declineRequest(guid)}
                onRequestDeleted={(guid)=>deleteRequest(guid)}
                availableActions={[
                    KEY_ABSENCEREQUEST_ACTION_ACCEPT,
                    KEY_ABSENCEREQUEST_ACTION_DENY,
                    KEY_ABSENCEREQUEST_ACTION_DELETE
                ]}
                onPageChange={(number) => setRequestPage(number - 1)}
                itemsPerPage={response.pageable.pageSize}
                totalItems={response.totalElements}
                currentPage={requestPage + 1}
            /> 

            : <Loading/>

        }


    </>

}

export default EmployeeAbsences